/**
 * @ Author: Your name
 * @ Create Time: 2020-04-28 17:47:03
 * @ Modified by: Your name
 * @ Modified time: 2020-11-24 18:12:13
 * @ Description:
 */

import router from '@core/router/'
import api from '@core/api'
import utils from '@/utils/'
import session from '@/utils/session'
import developMenu from './developMenu'
// import routesConf from '@core/router/routesConf'
export default {
  state: {
    menuTreeRight: [],
    menuTree: [],
    menuActive: '',
    menuList: [] // 后台返回的权限列表
  },
  getters: {
    menuActive: state => {
      return state.menuActive
    },
    /* menuActiveRoute: state => {
      const activeMenu = state.menuTree.find(menu => menu.name === state.menuActive)
      return activeMenu
    }, */
    menuTreeRight: function (e) {
      return e.menuTreeRight
    },
    menuActiveRoute: state => {
      // 1. 在 menuTree 中查找
      let activeMenuItem = state.menuTree.find(item => item.name === state.menuActive)

      // 2. 如果在 menuTree 中未找到，则在 menuTreeRight 中查找
      if (!activeMenuItem) {
        activeMenuItem = state.menuTreeRight.find(item => item.name === state.menuActive)
      }

      // 3. 返回找到的菜单项
      return activeMenuItem
    },
    menuTree: state => {
      return state.menuTree
    },
    menuList: state => {
      return state.menuList
    },
    /* childrenRoutes: state => {
      // 根据tabs的活动项去获取路由
      const activeMenuChildren = state.menuTree.find(menu => menu.name === state.menuActive).children
      return activeMenuChildren
    } */
    childrenRoutes: state => {
      // 尝试从 e.menuTree 中筛选出匹配的菜单项
      let matchedItems = state.menuTree.filter(item => item.name === state.menuActive)

      // 如果在 e.menuTree 中未找到匹配项，则从 e.menuTreeRight 中筛选
      if (matchedItems.length === 0) {
        matchedItems = state.menuTreeRight.filter(item => item.name === state.menuActive)
      }

      // 返回匹配菜单项的 children 属性
      return matchedItems[0] ? matchedItems[0].children : []
    }
  },
  mutations: {
    setMenuTreeRight (state, value) {
      state.menuTreeRight = value
    },
    setMenuTree (state, value) {
      state.menuTree = value
      // session.set('menuTree', value)
    },
    setMenuList (state, value) {
      state.menuList = value
    },
    setMenuActiveOnly (state, value) {
      state.menuActive = value
    },
    setMenuActive (state, value) {
      state.menuActive = value
    },
    addMenu ({menuTree}, value) {
      menuTree.push(value)
      // session.set('menuTree', menuTree)
    },
    removeMenu ({menuTree}, value) {
      const index = menuTree.findIndex(menu => menu.name === value)
      menuTree.splice(index, 1)
      session.set('menuTree', menuTree)
    }
  },
  actions: {
    // menu相关
    fetchMenuTree ({commit, getters}) {
      let params = {
        userId: getters.userInfo.id
      }
      return new Promise((resolve, reject) => {
        api.userService.getUserMenus(params).then(data => {
          if (!data.errorMessage) {
            let menuList = data.body || []
            // 测试菜单 TODO
            if (utils.isDevelop()) {
              developMenu.forEach(menu => {
                menuList.push(menu)
              })
            }
            // 测试菜单
            // menuList.push({code: 'contract001003003'})
            // menuList.push({code: 'contract001004003'})
            // menuList.push({ code: 'payment010004' })
            commit('setMenuList', menuList)
            resolve()
          } else {
            // utils.logout(true)
            reject(new Error())
          }
        }).catch(err => {
          // utils.logout(true)
          console.log(err)
        })
      })
    },
    initMenu ({commit, state}) {
      // 1. 从路由配置中筛选出符合条件的路由
      const mainRoute = router.options.routes.find(route => route.name === 'mainRoute')
      let filteredRoutes = mainRoute.children
        .filter(route => route.name === 'datacensus' || !route.meta.closeable)
        .sort((a, b) => a.meta.sort - b.meta.sort)

      // 2. 根据权限过滤路由
      const validRoutes = utils.validRouters(filteredRoutes, state.menuList.map(menu => menu.code))

      // 3. 排除特定路由
      const finalRoutes = validRoutes.filter(route => route.meta.menuId !== 'datacensus')
      debugger
      // 4. 初始化菜单树
      if (state.menuTree.length === 0) {
        commit('setMenuTree', finalRoutes.filter(route => route.meta.menuId !== 'M1005001'))
        commit('setMenuTreeRight', finalRoutes.filter(route => route.meta.menuId === 'M1005001'))
      }

      // 5. 设置默认激活菜单
      if (state.menuActive.length === 0) {
        const currentHash = location.hash
        const matchedRoute = finalRoutes.find(route => currentHash.includes(route.path))

        // 递归查找默认路由
        const findDefaultRoute = (routes) => {
          for (const route of routes) {
            if (route.children && route.children.length > 0) {
              return findDefaultRoute(route.children)
            }
            return route.name
          }
        }

        const defaultRouteName = matchedRoute ? matchedRoute.name : finalRoutes[0].name
        commit('setMenuActive', defaultRouteName)

        // 如果没有匹配的路由，则跳转到默认路由
        if (!matchedRoute) {
          const defaultRoute = findDefaultRoute(finalRoutes)
          router.push({name: defaultRoute})
        }
      }
    },
    /* initMenu ({commit, state}) {
      // 初始化菜单路由 menuTree。
      // 菜单路由只会被填充注入到main路由之下，所以一开始取的是main路由。
      // TODO
      // const routes = router.options.routes
      const routes = routesConf
      // let menuTree = routes.find(menu => menu.name === 'mainRoute').children.filter(menu => !menu.meta.closeable).sort((a, b) => a.meta.sort - b.meta.sort)
      let menuTree = routes.filter(menu => !menu.meta.closeable).sort((a, b) => a.meta.sort - b.meta.sort)
      // 针对业务模块中，需要将两个大菜单融合为1个菜单，进行特殊处理。
      const validatTree = utils.validRouters(menuTree, state.menuList.map(menu => menu.code))
      // 注册menuTree
      if (state.menuTree.length > 0) {
        // 取用历史缓存的menuTree,因为menuTree是会新增的，所以需要缓存
      // } else if (session.get('menuTree') && session.get('menuTree').length > 0) {
      //   commit('setMenuTree', session.get('menuTree'))
      } else {
        debugger
        commit('setMenuTree', validatTree)
      }

      // 取用历史缓存的已打开的页面
      if (state.menuActive.length > 0) {
      // } else if (session.get('menuActive')) {
      //   commit('setMenuActive', session.get('menuActive'))
      } else {
        const hash = location.hash
        const activeMenu = validatTree.find(menu => hash.indexOf(menu.path) !== -1)
        const routeName = _getFristRoute(validatTree)
        commit('setMenuActive', activeMenu ? activeMenu.name : validatTree[0].name)
        if (!activeMenu) {
          router.push({name: routeName})
        }
      }
      function _getFristRoute (menuTree) {
        let routeName = ''
        for (let i = 0; i < menuTree.length; i++) {
          if (menuTree[i].children && menuTree[i].children.length > 0) {
            routeName = _getFristRoute(menuTree[i].children)
            break
          } else {
            return menuTree[i].name
          }
        }
        if (routeName) {
          return routeName
        }
      }
    }, */
    setMenuTreeRight: ({commit}, value) => {
      commit('setMenuTreeRight', value)
    },
    setMenuActiveOnly ({commit}, value) {
      commit('setMenuActiveOnly', value)
    },
    setMenuActive ({commit, state}, menuName) {
      // 1. 更新 menuActive 状态
      commit('setMenuActive', menuName)

      // 2. 查找菜单项
      let menuItem = state.menuTree.find(item => item.name === menuName)
      if (!menuItem) {
        menuItem = state.menuTreeRight.find(item => item.name === menuName)
      }

      // 3. 处理路由跳转
      if (menuItem) {
        if (menuItem.redirect) {
          if (menuItem.redirect === 'notice/mylist/todolist') {
            router.push({name: 'todoList'})
          } else {
            // 如果有 redirect 配置，则跳转到第一个有效的子菜单
            utils.validRoutersJOSN2(menuItem.children, state.menuList, (validChild) => {
              const targetName = validChild ? validChild.name : menuName
              router.push({name: targetName})
            })
          }
        } else {
          // 否则直接跳转到当前菜单项
          router.push({name: menuName})
          if (menuItem.appType === 1) {
            router.push({name: 'application'})
          }
        }
      }
      /* commit('setMenuActive', value)
      router.push({name: value}) */
    },
    openMenu ({commit, state}, value) {
      const menu = state.menuTree.find(menu => menu.name === value.name)
      if (!menu) {
        commit('addMenu', value)
      }
      commit('setMenuActive', value.name)
      if (value.appType === 1) {
        router.push({name: 'application'})
      }
    },
    removeMenu ({commit, state}, value) {
      // 关闭的是当前页时，需要把active往前挪
      if (value === state.menuActive) {
        const index = state.menuTree.findIndex(menu => menu.name === value)
        const activeName = state.menuTree[index - 1] ? state.menuTree[index - 1].name : state.menuTree[index].name
        commit('setMenuActive', activeName)
        router.push({name: activeName})
        let menuItem = state.menuTree.find(item => item.name === activeName)
        if (!menuItem) {
          menuItem = state.menuTreeRight.find(item => item.name === activeName)
        }
        if (menuItem.appType === 1) {
          router.push({name: 'application'})
        }
      }
      commit('removeMenu', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/area-base/store/menu.js